"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustTokenMock__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }, {
    internalType: "address",
    name: "escrowFactory",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "AccessControlBadConfirmation",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "neededRole",
    type: "bytes32"
  }],
  name: "AccessControlUnauthorizedAccount",
  type: "error"
}, {
  inputs: [],
  name: "EnforcedPause",
  type: "error"
}, {
  inputs: [],
  name: "ExpectedPause",
  type: "error"
}, {
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [],
  name: "RemarkLengthExceeded",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotReturnedToIssuer",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "PauseWithRemark",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "UnpauseWithRemark",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "ACCEPTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MINTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "RESTORER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burnInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "genesis",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "mint",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "mintInternal",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "remark",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "callerConfirmation",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "baseURI",
    type: "string"
  }],
  name: "setBaseURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "adminRole",
    type: "bytes32"
  }],
  name: "setRoleAdmin",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "titleEscrowFactory",
  outputs: [{
    internalType: "contract ITitleEscrowFactory",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TradeTrustTokenMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(name, symbol, escrowFactory, overrides) {
    return super.getDeployTransaction(name, symbol, escrowFactory, overrides || {});
  }
  deploy(name, symbol, escrowFactory, overrides) {
    return super.deploy(name, symbol, escrowFactory, overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TradeTrustTokenMock__factory = TradeTrustTokenMock__factory;
_defineProperty(TradeTrustTokenMock__factory, "bytecode", _bytecode);
_defineProperty(TradeTrustTokenMock__factory, "abi", _abi);